import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationPanel } from '../navigation/navigation-panel/navigation-panel';

@Component({
  selector: 'app-home',
  imports: [
    RouterOutlet,
    NavigationPanel,
  ],
  templateUrl: './home.html',
  styleUrl: './home.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Home {}
